const atualizarCompartimentos = (state, compartimentos) => {
    state.compartimentos = compartimentos;
}

const atualizarCompartimento = (state, compartimento) => {
    state.compartimento = compartimento;
}

const atualizarCompartimentoPorPlano = (state, compartimentoPlanos) => {
    state.periodicidadePlanos = compartimentoPlanos;
}

const updateCompartimento = (state, compartimento) => {
    const item = state.compartimentos.find(item => item.id === compartimento.id);

    Object.assign(item, compartimento);
}

export default {
    atualizarCompartimentos,
    atualizarCompartimento,
    atualizarCompartimentoPorPlano,
    updateCompartimento
}
